import MonitorClass from '@monsters/tracer-rattata'

const MONITOR_TOKEN = 'pingpong-acquirer-web'
const VUE_APP_MONITOR_ENV = process.env.VUE_APP_MONITOR_ENV
const DEBUG_LOCAL_STORAGE_KEY = 'monitor:debug'

let monitorInstance = null
let createFailed = false
let initLogged = false

const isDebugEnabled = () => process.env.VUE_APP_MONITOR_DEBUG === 'true' ||
	localStorage.getItem(DEBUG_LOCAL_STORAGE_KEY) === '1'

const debugLog = (method, ...args) => {
	if (!isDebugEnabled()) {
		return
	}
	console[method]('[monitor]', ...args)
}

const createMonitor = () => {
	if (monitorInstance || createFailed) {
		return monitorInstance
	}

	try {
		monitorInstance = new MonitorClass(MONITOR_TOKEN, VUE_APP_MONITOR_ENV, {
			debug: isDebugEnabled(),
			autoTrack: false,
			page: false,
			request: false,
			ga: {
				enabled: false
			},
			ba: {
				enabled: false,
				OCPC: false
			},
			fb: {
				enabled: false
			}
		})
		debugLog('info', 'initialized', {
			token: MONITOR_TOKEN,
			env: VUE_APP_MONITOR_ENV
		})
		return monitorInstance
	} catch (error) {
		createFailed = true
		debugLog('error', 'failed to initialize', error)
		return null
	}
}

export const initMonitor = () => {
	if (initLogged) {
		return monitorInstance
	}
	initLogged = true
	return createMonitor()
}

export const reportMonitorEvent = async(eventName, payload = {}) => {
	const monitor = monitorInstance || createMonitor()
	if (!monitor) {
		debugLog('warn', 'skip trackEvent because monitor unavailable', {
			eventName,
			payload
		})
		return
	}

	try {
		debugLog('info', 'trackEvent', {
			eventName,
			payload
		})
		monitor.trackEvent(eventName, payload)
	} catch (error) {
		debugLog('error', 'trackEvent failed', {
			eventName,
			payload,
			error
		})
	}
}
